export var LibColor;
(function (LibColor) {
    LibColor["white"] = "#ffffff";
    LibColor["black"] = "#000000";
    LibColor["blue80"] = "#2b81cb";
    LibColor["blue90"] = "#308ddd";
    LibColor["blue100"] = "#3899ec";
    LibColor["blue120"] = "#4eb7f5";
    LibColor["dark10"] = "#162d3d";
    LibColor["dark30"] = "#20455e";
    LibColor["dark40"] = "#445968";
    LibColor["sky100"] = "#c1e4fe";
    LibColor["sky110"] = "#daeffe";
    LibColor["sky120"] = "#eaf7ff";
    LibColor["sky130"] = "#f4fafe";
    LibColor["sky150"] = "#f5f9fc";
    LibColor["grey50"] = "#577083";
    LibColor["grey70"] = "#7a92a5";
    LibColor["grey100"] = "#b6c1cd";
    LibColor["grey110"] = "#cbd2d9";
    LibColor["grey130"] = "#dfe5eb";
    LibColor["grey150"] = "#f0f4f7";
    LibColor["grey190"] = "#fafafa";
    LibColor["silver100"] = "#e6e6e6";
    LibColor["silver70"] = "#c8c8c8";
    LibColor["orange50"] = "#ea5f0e";
    LibColor["orange70"] = "#fb7d33";
    LibColor["orange100"] = "#ff9126";
    LibColor["orange120"] = "#ff9a48";
    LibColor["orange140"] = "#eda200";
    LibColor["orange150"] = "#fdb10c";
    LibColor["orange180"] = "#fedfba";
    LibColor["red100"] = "#d6453d";
    LibColor["red120"] = "#d8504c";
    LibColor["red140"] = "#ee5951";
    LibColor["red150"] = "#ff6666";
    LibColor["red190"] = "#ffd7d7";
    LibColor["green60"] = "#23a046";
    LibColor["green90"] = "#2cc958";
    LibColor["green100"] = "#3fd569";
    LibColor["green140"] = "#57e07d";
    LibColor["green180"] = "#cdf9da";
    LibColor["brown40"] = "#867650";
    LibColor["brown100"] = "#c68801";
    LibColor["yellow100"] = "#ffce00";
    LibColor["yellow180"] = "#fef0ba";
    LibColor["purple80"] = "#954DC8";
    LibColor["purple100"] = "#aa4dc8";
    LibColor["purple120"] = "#cd68ed";
    LibColor["cornflower"] = "#6572F5";
    LibColor["teal"] = "#3BB8D4";
    LibColor["turquoise"] = "#50E3C2";
    LibColor["rose"] = "#FF4F67";
})(LibColor || (LibColor = {}));
//# sourceMappingURL=colors-map.js.map